import { Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './form-drop-down.module.scss';

const FormDropdown = (props) => {
  const { label, messageErr, required, placeholder, value, options, setFormData, isError, disabled, borderColor, iconArrow, allowCustomValue } =
    props;
  const [defaultValue, setDefaultValue] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  const handleChange = (value) => {
    setFormData && setFormData(value);
  };

  const formattedOptions = useMemo(() => {
    const base = options;

    // If user is typing something not in list, add it
    if (searchValue && !base.some((opt) => opt.value === searchValue)) {
      return [
        ...base,
        {
          label: searchValue,
          value: searchValue,
        },
      ];
    }

    return base;
  }, [options, searchValue]);

  useEffect(() => {
    setDefaultValue(value || undefined);
  }, [value]);

  return (
    <div className={styles.container}>
      <div>
        <span className={styles.label}>{label}</span>
        <span style={{ color: '#FF787F' }}>{required && '*'}</span>
      </div>
      <div className={isError && styles.borderError}>
        <Select
          placeholder={placeholder}
          value={defaultValue}
          style={{
            width: '100%',
            borderColor: `${borderColor}`,
            borderRadius: '4px ',
          }}
          onChange={(val) => {
            setSearchValue('');
            handleChange(val);
          }}
          options={formattedOptions}
          disabled={disabled}
          data-testid="form-dropdown"
          suffixIcon={iconArrow}
          showSearch={allowCustomValue ? true : false}
          allowClear={allowCustomValue ? true : false}
          notFoundContent={null}
          onSearch={(val) => setSearchValue(val)}
        />
      </div>
      <div className={styles.error}>{isError && messageErr}</div>
    </div>
  );
};

export default FormDropdown;
